import { connect } from 'react-redux'
import NavButton from '../../components/navButton/navButtonComponent'
import { State } from '../../redux/reducers/'
import { actionCreators } from '../../redux/reducers/login/loginReducer'
import { actionCreators as uiActionCreators } from '../../redux/reducers/ui/uiReducer'
import { actionCreators as gradPlannerActions } from '../../redux/reducers/gradPlanner/gradPlannerReducer'

export function mapStateToProps (state: State, props): Values {
  return { display: state.login.authorized }
}
// export const propsMapping: Callbacks = {
//   onClick: actionCreators.reset
// }
export const propsMapping = (dispatch, ownProps) => {
  return {
    onClick: () => {
      // This is a hack but it works
      const signout = () => {
        dispatch(actionCreators.reset())
        dispatch(gradPlannerActions.reset())
      }
      if (ownProps.location.pathname === '/gradplanner') {
        dispatch(uiActionCreators.toggleNotificationModal())
        dispatch(
          uiActionCreators.changeNotification({
            header: 'beware',
            text: 'ifQuit',
            buttonText: 'keepGoing',
            icon: 'Skull',
            dismissText: 'quitAnyway',
            dismissFunc: signout
          })
        )
      } else {
        signout()
      }
    }
  }
}
export default connect(mapStateToProps, propsMapping)(NavButton)



// WEBPACK FOOTER //
// ./src/containers/logoutButton/logoutButtonContainer.js